import { Component } from '@angular/core';
import { getAveragesPerJob } from '@modules/reports/store/referral-reports.selectors';
import { Store } from '@ngrx/store';
import { AveragesPerJob } from '@shared/models/averages-per-job';
import { tap, filter } from 'rxjs/operators';
import { ResponseTime, responseTimeAdapter } from '@modules/reports/models/response-time';

@Component({
  selector: 'mojo-dashboard-averages',
  templateUrl: './dashboard-averages.component.html',
  styleUrls: ['./dashboard-averages.component.scss'],
})
export class DashboardAveragesComponent {
  responseTimeObj: ResponseTime;

  constructor(private store: Store) {}

  averagesPerJob$ = this.store.select(getAveragesPerJob).pipe(
    filter(Boolean),
    tap((data: AveragesPerJob) => {
      this.responseTimeObj = responseTimeAdapter(data.hiringManagerResponseTime);
    }),
  );
}
